/***************************************************************************** */
/* The ChatBotLaunch.js is used to lazy load the heavy Chatbot javascript into */
/* the DOM after any user interaction                                          */
/***************************************************************************** */

import Component from './Component';

export default class ChatBotLaunch extends Component {
  load() {
    this.initChatBotLaunch();
    super.load();
  }

  initChatBotLaunch() {
    // console.log('chat bot launcher script');
    if (document.querySelector('#sachatbot')) {
        // console.log('#sachatbot id exists')
        // console.log('chat bot launcher ready');
        var chatBotInitialized = false;
        var docBody = document.querySelector('body');

        // on touch
        docBody.ontouchstart = initChatBotScripts;

        // on mouse wheel
        docBody.onwheel = initChatBotScripts;

        // on view scroll
        window.addEventListener('scroll', function (ev) {
            initChatBotScripts();
        });

        // on mouse move
        docBody.addEventListener('mousemove', function (ev)  {
            initChatBotScripts();
        });

        // on mouse button down
        docBody.addEventListener('mousedown', function (ev) {
            initChatBotScripts();
        });

        function setExternalScript(src) {
            return new Promise((resolve, reject) => {
                var scriptTag = document.createElement('script');
                scriptTag.src = src;
                scriptTag.onload = () => resolve();
                document.body.appendChild(scriptTag);
            });
        }

        async function initChatBotScripts() {
          if (!chatBotInitialized) {  // only inject script once
                chatBotInitialized = true;
                // var scripts = ['https://sachatbot.blob.core.windows.net/chatbot/chatbot-runtime.js','https://sachatbot.blob.core.windows.net/chatbot/chatbot.js'];
                var scripts = ['/static/chatbot-runtime.js','/static/chatbot.js'];
                for (let i = 0; i < scripts.length; i++)
                    await setExternalScript(scripts[i]);
            }
        }
    } else {
        console.warn('error id #sachatbot missing.')
    }
  }
}
